module.exports = __webpack_public_path__ + "static/segemnts_options-d7f2841f4a50fa694eb19def25844fc1.png";